import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, IconButton, InputLabel } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import Flex from '@Components/Bases/Flex';
import FormTextAreaAutoSize from '@Components/Form/FormTextAreaAutosize';
import { disabledTextAreaInputStyles } from '@Components/Form/styles';
import DeleteModal from '@Components/Modal/DeleteModal';
import { useDisclosure } from '@hooks/useDisclosure';

type RemarkProps = {
  topic: string;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onDelete: () => void;
  fieldPath: string;
  isCompletedTh?: boolean;
  isCompletedEn?: boolean;
};

const Remark = ({
  topic,
  setOpen,
  fieldPath,
  onDelete,
  isCompletedTh = false,
  isCompletedEn = false,
}: RemarkProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { resetField, unregister } = useFormContext();

  const handleDelete = () => {
    if (typeof onDelete === 'function') {
      onDelete();
    } else {
      setOpen(false);
    }
    resetField(fieldPath);
    unregister(fieldPath);
  };

  return (
    <>
      <Box bgcolor={'grey.50'} p={2} pt={1}>
        <Flex justifyContent={'space-between'} sx={{ mb: 0.5 }}>
          <InputLabel>หมายเหตุ: {topic} (ไทย / อังกฤษ)</InputLabel>
          <IconButton
            color="inherit"
            size="small"
            sx={{ padding: 0 }}
            onClick={open}
            disabled={isCompletedTh || isCompletedEn}
          >
            <DeleteOutlineIcon style={{ fontSize: '16px' }} />
          </IconButton>
        </Flex>
        <Flex gap={1}>
          <FormTextAreaAutoSize
            name={`${fieldPath}.descriptionTh`}
            inputProps={{
              placeholder: 'กรุณาระบุหมายเหตุ (ไทย)',
              minRows: 3,
            }}
            flex={1}
            minWidth={200}
            sx={isCompletedTh ? disabledTextAreaInputStyles : {}}
          />
          <FormTextAreaAutoSize
            name={`${fieldPath}.descriptionEn`}
            inputProps={{
              placeholder: 'กรุณาระบุหมายเหตุ (อังกฤษ)',
              minRows: 3,
            }}
            flex={1}
            minWidth={200}
            sx={isCompletedEn ? disabledTextAreaInputStyles : {}}
          />
        </Flex>
      </Box>
      <DeleteModal
        topic={`หมายเหตุ ${topic}`}
        opened={opened}
        close={close}
        confirm={handleDelete}
      />
    </>
  );
};

export default Remark;
